import React, { Component } from 'react'

import { Row, Col } from 'antd'

import { UnitWrapper } from './style'

import u1 from '../../assets/img/u1.png'
import u2 from '../../assets/img/u2.png'
import u3 from '../../assets/img/u3.png'
import u4 from '../../assets/img/u4.png'
import u5 from '../../assets/img/u5.png'
import u6 from '../../assets/img/u6.png'
import u7 from '../../assets/img/u7.png'
import u8 from '../../assets/img/u8.png'
import u9 from '../../assets/img/u9.png'
import u10 from '../../assets/img/u10.png'
import u11 from '../../assets/img/u11.png'
import u12 from '../../assets/img/u12.png'
import u13 from '../../assets/img/u13.png'
import u14 from '../../assets/img/u14.png'
import u15 from '../../assets/img/u15.png'
import u16 from '../../assets/img/u16.png'
import u17 from '../../assets/img/u17.png'

export default class Unit extends Component {
    render() {
        return (
            <UnitWrapper>
                <div className="unitBox">
                    <div className="unitCon">
                        <Row>
                            <Col span={12}>
                                <dl>
                                    <dt>指导单位</dt>
                                    <dd>
                                        <img src={u1} alt="" />
                                        <img style={{ width: '48px', height: '48px' }} src={u2} alt="" />
                                    </dd>
                                </dl>
                            </Col>
                            <Col span={12}>
                                <dl>
                                    <dt>主办单位</dt>
                                    <dd>
                                        <img src={u3} alt="" />
                                    </dd>
                                </dl>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12}>
                                <dl>
                                    <dt>承办单位</dt>
                                    <dd>
                                        <img style={{ height: '30px' }} src={u4} alt="" />
                                        <img src={u5} alt="" />
                                    </dd>
                                </dl>
                            </Col>
                            <Col span={12}>
                                <dl>
                                    <dt>协办单位</dt>
                                    <dd>
                                        <img src={u6} alt="" />
                                        <img src={u7} alt="" />
                                    </dd>
                                </dl>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <dl>
                                    <dt>支持单位</dt>
                                    <dd>
                                        <img src={u8} alt="" />
                                    </dd>
                                </dl>
                            </Col>

                        </Row>
                        <Row>
                            <Col span={24}>
                                <dl>
                                    <dt>合作伙伴</dt>
                                    <dd>
                                        <img style={{ height: '26px' }} src={u9} alt="" />
                                        <img src={u10} alt="" />
                                        <img style={{ height: '26px' }} src={u11} alt="" />
                                        <img style={{ height: '28px' }} src={u12} alt="" />
                                        <img style={{ height: '29px' }} src={u13} alt="" />
                                        <img style={{ height: '27px' }} src={u14} alt="" />
                                        <img src={u15} alt="" />
                                        <img style={{ height: '25px' }} src={u16} alt="" />
                                        <img src={u17} alt="" />
                                    </dd>
                                </dl>
                            </Col>

                        </Row>
                    </div>
                </div>
            </UnitWrapper>
        )
    }
}
